// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../../../../../services/api';

const searchAddressService = async (data) => {
  return api('https://api.craftyclicks.co.uk/address/1.1/find', data, 'POST');
};

const selectedAddressService = async (data) => {
  return api('https://api.craftyclicks.co.uk/address/1.1/retrieve', data, 'POST');
};

export {
  searchAddressService,
  selectedAddressService,
};
